import {
    generateUUID,
    getDcfUrl,
    getEnvironment,
    DOMAIN_TYPE,
    DOMAIN_ENV,
    REPORTING_URL,
    BASE_KEY_URL
} from "./constants";
import axios from "axios";

export const SELECT_PRODUCT = "SELECT.PRODUCT";
export const SELECT_SAFEKEYAUTH_CARDS = "SELECT.SAFEKEYAUTH.CARDS";
export const UPDATE_ENVIRONMENT = "UPDATE.ENVIRONMENT";
export const UPDATE_IPC_ZONE = "UPDATE.IPC.ZONE";
export const UPDATE_ROUTE = "UPDATE.ROUTE";
export const UPDATE_DCF_WINDOW = "UPDATE.DCF.WINDOW";
export const UPDATE_VERSION = "UPDATE.VERSION";
export const UPDATE_SANDBOX_SDK = "UPDATE.SANDBOX.SDK";
export const UPDATE_INIT_REQUEST = "UPDATE.INIT.REQUEST";
export const UPDATE_LOGGING = "UPDATE.LOGGING";
export const UPDATE_DCF_URL = "UPDATE.DCF.URL";
export const UPATE_PARTNER_TOKENS = "UPATE.PARTNER.TOKENS";
export const UPATE_PARTNER_TOKENS_FLAG = "UPATE.PARTNER.TOKENS.FLAG";
export const UPATE_SAFEKEY_FLAGS = "UPATE.SAFEKEY.FLAGS";
export const UPDATE_CHANNELS = "UPDATE.CHANNELS";
export const UPDATE_SELECTED_CHANNEL = "UPDATE_SELECTED_CHANNEL";
export const UPDATE_GREEN_FLAG = "UPDATE.GREEN.FLAG";
export const UPDATE_ADVANCED_ENV = "UPDATE.ADVANCED.ENV";
export const UPDATE_AUTH_CODE = "UPDATE.AUTH.CODE";
export const UPDATE_AUTH_FLAG = "UPDATE.AUTH.FLAG";
export const UPDATE_SESSION_ID = "UPDATE.SESSION.ID";

const DEFAULT = {
    version: null,
    initRequest: {
        srciTransactionId: generateUUID(),
        srcInitiatorId: "d4f9feb0-177e-49bc-9dbc-94e8c98a3f14",
        dpaData: {},
        dpaTransactionOptions: {}
    },
    env: "",
    route: "blue",
    zone: "gdha",
    sandbox: false,
    greenEnv: false,
    dcfWindow: "frame",
    products: [
        {
            productName: "Laptop",
            price: 500,
            tax: "60",
            total: "560",
            image: "http://icm.aexp-static.com/Internet/IMDC/src/images/testPage/item-3.png",
        },
        {
            productName: "OLED TV",
            price: 1500,
            tax: "150",
            total: "1650",
            image: "http://icm.aexp-static.com/Internet/IMDC/src/images/testPage/item-2.png",
        },
        {
            productName: "Mobile Phone",
            price: 30,
            tax: "3",
            total: "33",
            image: "http://icm.aexp-static.com/Internet/IMDC/src/images/testPage/item-1.png",
        },
    ],
    selectedProduct: {
        name: "Laptop",
        price: 500,
        tax: "60",
        total: "560",
        image: "http://icm.aexp-static.com/Internet/IMDC/src/images/testPage/item-3.png",
    },
    setSafeKeyAuthCards: {

    },
    logging: {
        console: true,
        api: true
    },
    dcfUrl: getDcfUrl(),
    partnerTokens: null,
    usePartnerTokens: false,
    safekey: {
        stop: false,
        delay: false
    },
    channels: [],
    selectedChannel: {},
    advancedEnv: false,
    authenticated: false,
    authenticationCode: null,
    sessionId: null
};


export default function reducer(src: any = DEFAULT, action: any = {}) {
    switch (action.type) {
        case SELECT_PRODUCT:
            return {...src, selectedProduct: action.product};
        case SELECT_SAFEKEYAUTH_CARDS:
            return {...src, safeKeyAuthCards: action.payload};
        case UPDATE_ENVIRONMENT:
            return {...src, env: action.env};
        case UPDATE_ROUTE:
            return {...src, route: action.route};
        case UPDATE_IPC_ZONE:
            return {...src, zone: action.zone};
        case UPDATE_DCF_WINDOW:
            return {...src, dcfWindow: action.val};
        case UPDATE_VERSION:
            return {...src, version: action.version};
        case UPDATE_SANDBOX_SDK:
            return {...src, sandbox: action.flag};
        case UPDATE_INIT_REQUEST:
            return {...src, initRequest: action.payload};
        case UPDATE_LOGGING:
            return {...src, logging: action.payload};
        case UPDATE_DCF_URL:
            return {...src, dcfUrl: action.url};
        case UPATE_PARTNER_TOKENS:
            return {...src, partnerTokens: action.tokens};
        case  UPATE_PARTNER_TOKENS_FLAG:
            return {...src, usePartnerTokens: action.flag};
        case  UPATE_SAFEKEY_FLAGS:
            return {...src, safekey: action.payload};
        case  UPDATE_CHANNELS:
            return {...src, channels: action.payload};
        case  UPDATE_SELECTED_CHANNEL:
            return {...src, selectedChannel: action.payload};
        case  UPDATE_GREEN_FLAG:
            return {...src, greenEnv: action.flag};
        case  UPDATE_ADVANCED_ENV:
            return {...src, advancedEnv: action.flag};
        case  UPDATE_AUTH_FLAG:
            return {...src, authenticated: action.flag};
        case  UPDATE_AUTH_CODE:
            return {...src, authenticationCode: action.code};
        case  UPDATE_SESSION_ID:
            return {...src, sessionId: action.code};
        default:
            break;
    }
    return src;
}

export function updateSessionId(code: any) {
    return {
        code,
        type: UPDATE_SESSION_ID
    };
}

export function updateAuthFlag(flag: any) {
    return {
        flag,
        type: UPDATE_AUTH_FLAG
    };
}

export function updateAuthCode(code: any) {
    return {
        code,
        type: UPDATE_AUTH_CODE
    };
}

export function updateSelectedChannel(payload: any) {
    return {
        payload,
        type: UPDATE_SELECTED_CHANNEL
    };
}

export function updateAdvancedEnvFlag(flag: any) {
    return {
        flag,
        type: UPDATE_ADVANCED_ENV
    };
}


export function updateChannels(payload: any) {
    return {
        payload,
        type: UPDATE_CHANNELS
    };
}

export function selectProduct(product: any) {
    return {
        product,
        type: SELECT_PRODUCT
    };
}

export function selectSafeKeyAuthCards(payload: any) {
    return {
        payload,
        type: SELECT_SAFEKEYAUTH_CARDS
    };
}

export function setSafeKeyAuthConfig(payload: any) {
    return {
        payload,
        type: SELECT_SAFEKEYAUTH_CARDS
    };
}

export function updateSafekeyFlags(payload: any) {
    return {
        payload,
        type: UPATE_SAFEKEY_FLAGS
    };
}


export function updatePartnerTokens(tokens: any) {
    return {
        tokens,
        type: UPATE_PARTNER_TOKENS
    };
}

export function updatePartnerTokensFlag(flag: any) {
    return {
        flag,
        type: UPATE_PARTNER_TOKENS_FLAG
    };
}

export function updateInit(payload: any) {
    return {
        payload,
        type: UPDATE_INIT_REQUEST
    };
}

export function updateEnvironment(env: string) {
    return {
        env,
        type: UPDATE_ENVIRONMENT
    };
}

export function updateRoute(route: string) {
    return {
        route,
        type: UPDATE_ROUTE
    };
}

export function updateZone(zone: string) {
    return {
        zone,
        type: UPDATE_IPC_ZONE
    };
}


export function updateVersion(version: string) {
    return {
        version,
        type: UPDATE_VERSION
    };
}

export function updateLogging(payload: any) {
    return {
        payload,
        type: UPDATE_LOGGING
    };
}


export function setDcfWindow(val: string) {
    return {
        val,
        type: UPDATE_DCF_WINDOW
    };
}

export function setSandboxFlag(flag: boolean) {
    return {
        flag,
        type: UPDATE_SANDBOX_SDK
    };
}

export function setGreenFlag(flag: boolean) {
    return {
        flag,
        type: UPDATE_GREEN_FLAG
    };
}

export function updateDcfUrl(url: string) {
    return {
        url,
        type: UPDATE_DCF_URL
    };
}

export function updateEnv(env: string) {
    return (dispatch: any, getState: () => void) => {
        let dcfUrl = getDcfUrl(env);
        dispatch(updateDcfUrl(dcfUrl));
        dispatch(updateEnvironment(env));
    };
}


export function setVersion(version: string) {
    return (dispatch: any, getState: () => void) => {
        let config = window.requestConfig[version];
        let initRequest = config.init;
        let state: any = getState();
        // let newInitRequest = {...state.initRequest, ...initRequest};
        dispatch(updateVersion(version));
        dispatch(updateInit(initRequest));
    };
}

export function authenticateSession(id) {
    return (dispatch: any, getState: () => void) => {
        const state: any = getState();
        axios({
            method: "GET",
            url: `${REPORTING_URL}/accessControl/${id}`,
            timeout: 6000,
        }).then((response: any) => {
            dispatch(updateAuthFlag(true));
            dispatch(updateAuthCode(id));
        }).catch(err => {
            dispatch(updateAuthFlag(false));
        });

    };
}




